module.exports = __webpack_public_path__ + "static/media/garyBorn.105e1a75.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/garyBorn.jpg
// module id = 1568
// module chunks = 1